export default __webpack_public_path__ + "static/media/bookmark_img.09c79739.png";